import * as dzsapp from './js_dzsapp/_plugins_add_documentation';

jQuery(document).ready(function ($) {
  if(String(window.location.href).indexOf('plugins.php')>-1){
    dzsapp.addDocumentationInPluginsPage();
  }
});